/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Card,
    Col,
} from "react-bootstrap";
import { BsPatchCheckFill } from "react-icons/bs";
import { FaBed, FaChild } from "react-icons/fa";
import { FaPerson } from "react-icons/fa6";
import { BiCheck } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import { formatPrice } from "helpers/common";
import CancellationModal from "./CancellationModal";
import useCheckRate from "hooks/hotel/useCheckRate";
import { square } from "ldrs";
square.register();

const getRates = (hotel, rooms) => {
    if (!hotel.rates) {
        return [];
    }
    let hotelRatesKeys = Object.keys(hotel.rates);
    if(!hotelRatesKeys || hotelRatesKeys.length === 0) {
        return [];
    }
    const rates = [];

    // If the hotel rates keys are not matching the rooms, we need to generate them based on the rooms
    if (hotelRatesKeys.length < rooms.length) {
        hotelRatesKeys = [];
        rooms?.forEach((room) => {
            let  roomKey = `${room.adults},${room.children}`;
            const ages =  room?.childrenAges.sort((a, b) => a - b);
            if(ages && ages.length > 0) {
                roomKey += `-${ages.join(',')}`
            }
            hotelRatesKeys.push(roomKey);
        });
    }

    hotelRatesKeys.forEach((room, i) => {
        rates.push([]);
        const guests = room.split("-")[0];
        const adults = Number.parseInt(guests.split(",")[0]);
        const children = Number.parseInt(guests.split(",")[1]);
        Object.keys(hotel?.rates[room])?.forEach((rate) => {
            hotel.rates[room][rate].forEach((r) => {
                rates[i].push({
                    name: hotel.rooms[rate].name,
                    pension: r.boardName,
                    price: r.net.total,
                    currency: r.net.currency,
                    rateKey: r.rateKey,
                    selected: false,
                    cancellationPolicies: r?.cancellationPolicies,
                    persons: {
                        adults,
                        children,
                    },
                    supplements : r.supplements || [],
                });
            });
        });
    });
    rates.forEach((rate) => {
        rate = rate.sort((a, b) => a.price - b.price);
        rate[0].selected = true;
    });
    return rates;
};

const NotCombinedRooms = ({ hotel, isLoading }) => {
    const hotelState = JSON.parse(localStorage.getItem("hotelState") || "{}");
    const rooms = hotelState.rooms;
    const allRates = getRates(hotel, rooms);
    let boards = [
        "All",
        ...allRates
            .map((rates) => {
                return rates.map((rate) => {
                    return `${rate.pension}`;
                });
            })
            .flat(),
    ];

    // remove duplicates
    boards = [...new Set(boards)];


    
    const { t } = useTranslation();
    const [filteredRates, setFilteredRates] = useState([]);
    const [selectedBoardsPerRoom, setSelectedBoardsPerRoom] = useState(
        Array.from({ length: rooms.length }, () => ["All"])
    );
    const [selectedRates, setSelectedRates] = useState([]);
    const { goToDetailsNotCombined } = useCheckRate(hotel);
    useEffect(() => {
        const newFilteredRates = allRates?.map((rates, roomIdx) => {
            return rates.filter((rate) => {
                return (
                    selectedBoardsPerRoom[roomIdx].includes("All") ||
                    selectedBoardsPerRoom[roomIdx].includes(rate.pension)
                );
            });
        });
        setFilteredRates(newFilteredRates);
    }, [selectedBoardsPerRoom, hotel]);

    useEffect(() => {
        setSelectedRates(
            filteredRates.map((rates) => {
                return rates.find((rate) => rate.selected) || rates[0];
            })
        );
    }, [filteredRates]);

    const handleBoardChange = (board, roomIdx) => {
        if (
            selectedBoardsPerRoom[roomIdx].includes(board) &&
            selectedBoardsPerRoom[roomIdx].length === 1
        )
            return;
        setSelectedBoardsPerRoom((prev) => {
            const newSelectedBoards = [...prev];

            if (board === "All") {
                newSelectedBoards[roomIdx] = ["All"];
            } else {
                if (prev[roomIdx].includes(board)) {
                    newSelectedBoards[roomIdx] = prev[roomIdx].filter(
                        (b) => b !== board
                    );
                } else {
                    newSelectedBoards[roomIdx] = prev[roomIdx]
                        .filter((b) => b !== "All")
                        .concat(board);
                }
            }
            return newSelectedBoards;
        });
    };

    const handleSelection = (idx, i) => {
        setFilteredRates((prev) => {
            return prev.map((roomRates, roomIdx) => {
                return roomRates.map((rateItem, rateIdx) => {
                    if (roomIdx === i) {
                        if (rateIdx === idx) {
                            return {
                                ...rateItem,
                                selected: true,
                            };
                        }
                        return {
                            ...rateItem,
                            selected: false,
                        };
                    }
                    return {
                        ...rateItem,
                    };
                });
            });
        });
    };

    return (
        <div className="">
            {isLoading && (
                <div
                    className="w-100 d-flex justify-content-center align-items-center"
                    style={{ height: "60dvh" }}
                >
                    <l-square
                        size="40"
                        stroke="3.5"
                        speed="1"
                        color="black"
                    ></l-square>
                </div>
            )}
            {!isLoading && (
                <>
                    <Accordion
                        alwaysOpen
                        defaultActiveKey="1"
                        className="accordion-icon accordion-bg-light"
                        id="accordionExample2"
                    >
                        {filteredRates.map((rates, i) => {
                            return (
                                <AccordionItem
                                    key={i}
                                    eventKey={`${i + 1}`}
                                    className="my-2 "
                                >
                                    <AccordionHeader
                                        as="div"
                                        className="bg-hover-color/35 fw-bold border-none"
                                    >
                                        <div className="text-main-color text-lg font-medium ">
                                            {t("room")} {`${i + 1}`}
                                        </div>
                                    </AccordionHeader>
                                    <AccordionBody className="p-0">
                                        <ul
                                            className=" d-flex gap-2 mb-0 px-3 g-3 p-2 room"
                                            style={{
                                                flexWrap: "nowrap",
                                                overflowX: "auto",
                                            }}
                                        >
                                            {boards?.map((board, idx) => (
                                                <div
                                                    key={idx}
                                                    onClick={() =>
                                                        handleBoardChange(
                                                            board,
                                                            i
                                                        )
                                                    }
                                                    className="list-inline-item mb-0"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="btn-check "
                                                        id={`btn-check-${i}${idx}`}
                                                        checked={selectedBoardsPerRoom[
                                                            i
                                                        ].includes(board)}
                                                    />
                                                    <label
                                                        className={`btn text-nowrap btn-sm hover:text-black ${
                                                            selectedBoardsPerRoom[
                                                                i
                                                            ].includes(board)
                                                                ? "bg-hover-color text-main-color"
                                                                : " "
                                                        } `}
                                                        id={`btn-check-${i}${idx}`}
                                                    >
                                                        {t(board.toLowerCase())}
                                                    </label>
                                                </div>
                                            ))}
                                        </ul>
                                        <Card className="px-2 border-none  d-flex d-flex-column rounded-0 room ">
                                            {rates.map((rate, idx) => {
                                                return (
                                                    <Card
                                                        key={idx}
                                                        className="card-body  rounded-1 p-3 mb-2 bg-modal"
                                                    >
                                                        <Col>
                                                            <div className="d-flex flex-column  flex-md-row justify-content-md-between  align-items-center justify-content-center">
                                                                <div
                                                                    dir="ltr"
                                                                    className="fw-bold text-md-start text-truncate"
                                                                >
                                                                    {rate.name}
                                                                </div>
                                                                <div
                                                                    dir="ltr"
                                                                    className="gap-2 d-flex  min-w-[100px]  text-main-color p-0 align-items-center text-truncate"
                                                                >
                                                                    <BsPatchCheckFill className=" " />
                                                                    {
                                                                        rate.pension
                                                                    }
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col className="d-flex flex-column  flex-md-row justify-content-md-between  align-items-center justify-content-center my-3">
                                                            <div className="text-center text-md-start">
                                                                <div
                                                                    key={idx}
                                                                    className="d-flex align-items-center gap-2 mb-1"
                                                                >
                                                                    <span className="fw-bold">
                                                                        <FaBed className="me-1" />
                                                                    </span>
                                                                    <span className="d-flex align-items-center">
                                                                        <FaPerson className="me-1" />{" "}
                                                                        {
                                                                            rooms[
                                                                                i
                                                                            ]
                                                                                .adults
                                                                        }{" "}
                                                                        {rooms[
                                                                            i
                                                                        ]
                                                                            .adults ===
                                                                        1
                                                                            ? t(
                                                                                  "adult"
                                                                              )
                                                                            : t(
                                                                                  "adults"
                                                                              )}
                                                                    </span>
                                                                    {rooms[i]
                                                                        .children >
                                                                        0 && (
                                                                        <span className="d-flex align-items-center ms-3">
                                                                            <FaChild className="me-1" />{" "}
                                                                            {
                                                                                rooms[
                                                                                    i
                                                                                ]
                                                                                    .children
                                                                            }{" "}
                                                                            {rooms[
                                                                                i
                                                                            ]
                                                                                .children ===
                                                                            1
                                                                                ? t(
                                                                                      "child"
                                                                                  )
                                                                                : t(
                                                                                      "children"
                                                                                  )}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <CancellationModal
                                                                key={idx}
                                                                rate={rate}
                                                                hotel={hotel}
                                                            />
                                                        </Col>
                                                        <Col>
                                                            <div className="d-flex justify-content-between align-items-center gap-4">
                                                                <div className="d-flex gap-2 fw-bold text-price ">
                                                                    {formatPrice(
                                                                        rate.price
                                                                    ).replace(
                                                                        "DA",
                                                                        t("DA")
                                                                    )}
                                                                </div>
                                                                <li
                                                                    key={idx}
                                                                    className="list-inline-item mb-0"
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        className="btn-check peer"
                                                                        id={`select${i}${idx}`}
                                                                        name={`select-room-${i}`}
                                                                        checked={
                                                                            rate.selected
                                                                        }
                                                                        onClick={() =>
                                                                            handleSelection(
                                                                                idx,
                                                                                i
                                                                            )
                                                                        }
                                                                    />

                                                                    <label
                                                                        className="btn btn-sm btn-light hover:text-black btn-primary-soft-check peer-checked:bg-hover-color peer-checked:text-main-color "
                                                                        htmlFor={`select${i}${idx}`}
                                                                    >
                                                                        <div className="d-flex align-items-center gap-1">
                                                                            {rate.selected ? (
                                                                                <>
                                                                                    <BiCheck
                                                                                        size={
                                                                                            22
                                                                                        }
                                                                                    />{" "}
                                                                                    <span>
                                                                                        {t(
                                                                                            "selected"
                                                                                        )}
                                                                                    </span>
                                                                                </>
                                                                            ) : (
                                                                                <span>
                                                                                    {t(
                                                                                        "select"
                                                                                    )}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </label>
                                                                </li>
                                                            </div>
                                                        </Col>
                                                    </Card>
                                                );
                                            })}
                                        </Card>
                                    </AccordionBody>
                                </AccordionItem>
                            );
                        })}
                    </Accordion>
                    <div
                        className="d-grid mt-4"
                        style={{
                            position: "sticky",
                            bottom: "0",
                        }}
                    >
                        <button
                            onClick={() => {
                                goToDetailsNotCombined(selectedRates);
                            }}
                            className={`btn py-2 text-white  bg-main-color mb-0 d-flex justify-content-center `}
                        >
                            {t("continue")} -{" "}
                            {`(${formatPrice(
                                selectedRates.reduce(
                                    (acc, rate) => acc + rate.price,
                                    0
                                )
                            ).replace("DA", t("DA"))})`}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default NotCombinedRooms;
